import {Component, OnInit, ViewChild} from '@angular/core';
import {IonContent} from '@ionic/angular';
import {EventsService} from 'src/app/services/event/event.service';

@Component({
  selector: 'app-tab-webview',
  templateUrl: './tab-webview.page.html',
  styleUrls: ['./tab-webview.page.scss'],
})
export class TabWebviewPage implements OnInit {
  @ViewChild(IonContent, {static: false}) content: IonContent;

  constructor(private events: EventsService) {}

  ngOnInit() {
    this.events.subscribe('event:reload:externallinks', () => {
      this.content.scrollToTop();
    });
  }
}
